export const dashify = (input)=>input ? input.toLocaleLowerCase().split(" ").join("-") : "";
export const undashifyAndCapitalise = (input)=>input ? input.replace(/-/g, " ").replace(/^./, input[0].toUpperCase()) : "";
